import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { LinksService } from '@isophi/core-legacy';
import { Menu } from '@isophi/teachers-shared';
import { TranslocoService } from '@jsverse/transloco';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

import { KindergartenService } from '../../../core/services/kindergarten.service';
import { ProductType } from '../../child/components/list-filter/list-filter.component';
import { MenuService, MenuType } from '../services/menu.service';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NavigationComponent implements OnInit, OnDestroy {
  menuData$: Observable<Menu[]>;



  productType = ProductType;

  private readonly menuService = inject(MenuService);

  private readonly transloco = inject(TranslocoService);

  private readonly cd = inject(ChangeDetectorRef);

  private readonly kindergartenService = inject(KindergartenService);

  private readonly linksService = inject(LinksService);

  private _subs: Subscription[] = [];

  protected readonly isSkKindergarten$ = new BehaviorSubject(this.kindergartenService.loggedKindergarten.isSKKindergarten());

  protected readonly isSchool$ = new BehaviorSubject(this.kindergartenService.loggedKindergarten.isSchool());

  protected readonly managementAddUserUrl = this.linksService.getManagementAppUrl({ redirect: '/settings/user/list' });

  ngOnInit(): void {
    this._loadMenu();
    this._subs.push(this.transloco.langChanges$.subscribe(() => this._loadMenu()));
  }

  preventMenuClose(event): void {
    if (event.target.className.includes('accordion-button')) {
      event.stopPropagation();
    }
  }

  private _loadMenu(): void {
    this.menuData$ = this.menuService.getMenu(MenuType.SIDE);
    this.cd.markForCheck();
  }

  ngOnDestroy(): void {
    this._subs.forEach((_sub) => _sub.unsubscribe());
  }
}
